import React, { useState } from 'react';
import { Heart, Star, CheckCircle2, User } from 'lucide-react';
interface Comment {
  id: number;
  handle: string;
  comment: string;
  likes: number;
  time: string;
  rating: number;
  liked?: boolean;
}
const initialComments: Comment[] = [{
  id: 1,
  handle: '@marta_wf_warszawa',
  comment: 'Używam systemu planowania tygodniowego od pierwszego tygodnia. Oszczędzam ponad 10 godzin tygodniowo. Warte każdej złotówki.',
  likes: 47,
  time: '3 godziny temu',
  rating: 5,
  liked: true
}, {
  id: 2,
  handle: '@tomasz_trener_krakow',
  comment: 'W dwa tygodnie skróciłem czas przygotowania o 80% bez zmiany metody nauczania. Sama checklista wystarczyła.',
  likes: 32,
  time: '5 godzin temu',
  rating: 5
}, {
  id: 3,
  handle: '@piotr_coach_gdansk',
  comment: 'Część dotycząca raportów dla rodziców otworzyła mi oczy. Nigdy wcześniej nie miałem tak jasnego systemu komunikacji.',
  likes: 28,
  time: '8 godzin temu',
  rating: 5,
  liked: true
}, {
  id: 4,
  handle: '@anna_wf_wroclaw',
  comment: 'Materiałów jest dużo, na początku myślałam że nie zdążę wszystkiego użyć — ale po posegregowaniu każda strona jest użyteczna.',
  likes: 19,
  time: '12 godzin temu',
  rating: 5
}, {
  id: 5,
  handle: '@krzysztof_trener_poznan',
  comment: 'Plan B na deszczowe dni uratował mnie już kilka razy. Wcześniej każdy deszczowy dzień to był natychmiastowy chaos.',
  likes: 24,
  time: 'wczoraj',
  rating: 5,
  liked: true
}];
const moreCommentsPool: Comment[] = [{
  id: 6,
  handle: '@michal_wf_lodz',
  comment: 'Rozgrzewki z bonusu to złoto. Dziewczyny je uwielbiają, a ja mam spokój gdy coś idzie nie tak.',
  likes: 18,
  time: '6 godzin temu',
  rating: 5
}, {
  id: 7,
  handle: '@akademia_siatkowki_warszawa',
  comment: 'Używamy tego systemu w całej akademii. Standaryzacja pracy trenerów nigdy nie była tak prosta.',
  likes: 31,
  time: '14 godzin temu',
  rating: 5,
  liked: true
}, {
  id: 8,
  handle: '@pawel_trener_szczecin',
  comment: 'Kalendarz 365 to coś, czego szukałem od lat. Koniec z wymyślaniem wszystkiego na bieżąco.',
  likes: 22,
  time: '18 godzin temu',
  rating: 5
}, {
  id: 9,
  handle: '@trener_maciej_lublin',
  comment: 'Rodzice są zachwyceni nowymi raportami. Widzą, że pracujemy profesjonalnie i mają czarno na białym postępy dzieci.',
  likes: 41,
  time: 'wczoraj',
  rating: 5,
  liked: true
}, {
  id: 10,
  handle: '@kamil_wf_katowice',
  comment: 'Pobierasz i masz. Żadnego logowania, żadnych abonamentów. Mam to na tablecie i korzystam na każdej lekcji.',
  likes: 15,
  time: 'wczoraj',
  rating: 5
}, {
  id: 11,
  handle: '@dawid_trener_bydgoszcz',
  comment: 'Moduł U16 to kopalnia wiedzy. Nawet po 10 latach pracy znalazłem tam nowe, świetne rozwiązania.',
  likes: 27,
  time: '2 dni temu',
  rating: 5,
  liked: true
}, {
  id: 12,
  handle: '@lukasz_coach_bialystok',
  comment: 'Komendy trenera z bonusu działają cuda. Dziewczyny słuchają od pierwszego gwizdka.',
  likes: 19,
  time: '2 dni temu',
  rating: 5
}];
export function SocialFeed() {
  const [comments, setComments] = useState<Comment[]>(initialComments);
  const [loadedExtra, setLoadedExtra] = useState(0);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [showThankYou, setShowThankYou] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    setShowThankYou(true);
    setNewComment('');
    setRating(0);
    setTimeout(() => setShowThankYou(false), 4500);
  };
  const toggleLike = (id: number) => {
    setComments(prev => prev.map(c => c.id === id ? {
      ...c,
      liked: !c.liked,
      likes: c.liked ? c.likes - 1 : c.likes + 1
    } : c));
  };
  const loadMore = () => {
    const next = moreCommentsPool.slice(loadedExtra, loadedExtra + 5);
    setComments(prev => [...prev, ...next]);
    setLoadedExtra(prev => prev + 5);
  };
  const hasMore = loadedExtra < moreCommentsPool.length;
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-267">
      <div className="max-w-3xl mx-auto" data-id="element-268">
        <div className="text-center mb-8 md:mb-12" data-id="element-269">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-2 md:mb-3" data-id="element-270">
            Opinie nauczycieli którzy już używają systemu
          </h2>
          <p className="text-sm md:text-base text-[#9BA3B5]" data-id="element-271">
            Ponad 1 200 nauczycieli zmieniło już sposób prowadzenia zajęć
          </p>
        </div>

        <div className="bg-[#1A3257] rounded-2xl shadow-lg p-5 md:p-8 mb-6 md:mb-8 border border-[#1E3A5F]" data-id="element-272">
          <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4" data-id="element-273">
            Zostaw swoją opinię:
          </h3>

          {showThankYou ? <div className="bg-[#2ECC71]/10 border border-[#2ECC71]/30 rounded-xl p-4 md:p-6 flex items-start gap-3 md:gap-4" data-id="element-274">
              <CheckCircle2 className="w-6 h-6 md:w-8 md:h-8 text-[#2ECC71] flex-shrink-0" data-id="element-275" />
              <div data-id="element-276">
                <p className="font-bold text-[#2ECC71] text-base md:text-lg mb-1" data-id="element-277">
                  Dziękujemy za Twoją opinię!
                </p>
                <p className="text-sm md:text-base text-[#E8EAF0]" data-id="element-278">
                  Twoja opinia zostanie opublikowana wkrótce po weryfikacji.
                </p>
              </div>
            </div> : <form onSubmit={handleSubmit} data-id="element-279">
              <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Napisz o swoich doświadczeniach z systemem Siatkówka Gotowa..." rows={3} className="w-full p-3 md:p-4 rounded-xl bg-[#0A1628] border border-[#1E3A5F] focus:border-gold-accent focus:outline-none transition-colors resize-none text-sm md:text-base text-[#E8EAF0] placeholder-[#9BA3B5]" data-id="element-280" />

              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-4" data-id="element-281">
                <div className="flex items-center gap-2 md:gap-3" data-id="element-282">
                  <span className="text-sm md:text-base text-[#9BA3B5] font-medium" data-id="element-283">
                    Oceń:
                  </span>
                  <div className="flex gap-1" data-id="element-284">
                    {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setRating(star)} className="transition-transform hover:scale-110" aria-label={`Oceń na ${star} gwiazdek`} data-id="element-285">
                        <Star className={`w-6 h-6 md:w-7 md:h-7 transition-colors ${(hoverRating || rating) >= star ? 'fill-gold-accent text-gold-accent' : 'text-[#1E3A5F]'}`} data-id="element-286" />
                      </button>)}
                  </div>
                </div>

                <button type="submit" disabled={!newComment.trim()} className="bg-gold-accent hover:bg-gold-light text-[#0A1628] font-bold px-6 py-2.5 md:px-8 md:py-3 rounded-full shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm md:text-base w-full sm:w-auto" data-id="element-287">
                  Wyślij opinię
                </button>
              </div>
            </form>}
        </div>

        <div className="space-y-4" data-id="element-288">
          {comments.map(comment => <div key={comment.id} className="bg-[#1A3257] rounded-2xl p-4 md:p-6 shadow-sm border border-[#1E3A5F]" data-id="element-289">
              <div className="flex items-start justify-between gap-3 mb-2" data-id="element-290">
                <div className="flex items-center gap-2 md:gap-3 min-w-0" data-id="element-291">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#0A1628] flex items-center justify-center flex-shrink-0" data-id="element-292">
                    <User className="w-4 h-4 md:w-5 md:h-5 text-gold-accent" data-id="element-293" />
                  </div>
                  <span className="font-bold text-white text-sm md:text-base truncate" data-id="element-294">
                    {comment.handle}
                  </span>
                </div>
                <div className="flex gap-0.5 flex-shrink-0" data-id="element-295">
                  {[...Array(comment.rating)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-gold-accent text-gold-accent" data-id="element-296" />)}
                </div>
              </div>

              <p className="text-sm md:text-base text-[#E8EAF0] leading-relaxed mb-3" data-id="element-297">
                {comment.comment}
              </p>

              <div className="flex items-center gap-3 md:gap-4 text-xs md:text-sm" data-id="element-298">
                <button onClick={() => toggleLike(comment.id)} className="flex items-center gap-1.5 group" aria-label="Lubię to" data-id="element-299">
                  <Heart className={`w-4 h-4 md:w-5 md:h-5 transition-all group-hover:scale-110 ${comment.liked ? 'fill-[#E63946] text-[#E63946]' : 'text-[#9BA3B5] group-hover:text-[#E63946]'}`} data-id="element-300" />
                  <span className={comment.liked ? 'text-[#E63946] font-medium' : 'text-[#9BA3B5]'} data-id="element-301">
                    {comment.likes}
                  </span>
                </button>
                <span className="text-[#1E3A5F]" data-id="element-302">•</span>
                <span className="text-[#9BA3B5]" data-id="element-303">{comment.time}</span>
              </div>
            </div>)}
        </div>

        {hasMore && <div className="flex justify-center mt-6 md:mt-8" data-id="element-304">
            <button onClick={loadMore} className="bg-[#1A3257] hover:bg-[#1E3A5F] text-white font-bold px-6 py-2.5 md:px-8 md:py-3 rounded-full shadow-sm border border-[#1E3A5F] hover:border-gold-accent transition-all text-sm md:text-base" data-id="element-305">
              Załaduj 5 kolejnych opinii
            </button>
          </div>}

        {!hasMore && comments.length > 5 && <p className="text-center text-[#9BA3B5] mt-6 md:mt-8 text-xs md:text-sm" data-id="element-306">
            Widzisz wszystkie opinie
          </p>}
      </div>
    </section>;
}